export enum FormModes {
  CREATE = 'create',
  UPDATE = 'update',
}
